import { render, staticRenderFns } from "./AccountingPropertyView.vue?vue&type=template&id=324786da&scoped=true"
import script from "./AccountingPropertyView.vue?vue&type=script&lang=js"
export * from "./AccountingPropertyView.vue?vue&type=script&lang=js"
import style0 from "./AccountingPropertyView.vue?vue&type=style&index=0&id=324786da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324786da",
  null
  
)

export default component.exports